/* eslint-disable */
import _m0 from "protobufjs/minimal";
import {
  ImuMuxSourcePb_Enum,
  imuMuxSourcePb_EnumFromJSON,
  imuMuxSourcePb_EnumToJSON,
} from "../../../../gen/imu/imu_mux_source";

export const protobufPackage = "skills";

export interface SetDesiredImuSourceActionArgs {
  source: ImuMuxSourcePb_Enum;
}

export interface SetDesiredImuSourceResultData {
}

export interface SetDesiredImuSourceActionStateData {
}

function createBaseSetDesiredImuSourceActionArgs(): SetDesiredImuSourceActionArgs {
  return { source: 0 };
}

export const SetDesiredImuSourceActionArgs = {
  encode(message: SetDesiredImuSourceActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.source !== 0) {
      writer.uint32(8).int32(message.source);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetDesiredImuSourceActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDesiredImuSourceActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.source = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetDesiredImuSourceActionArgs {
    return { source: isSet(object.source) ? imuMuxSourcePb_EnumFromJSON(object.source) : 0 };
  },

  toJSON(message: SetDesiredImuSourceActionArgs): unknown {
    const obj: any = {};
    if (message.source !== 0) {
      obj.source = imuMuxSourcePb_EnumToJSON(message.source);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetDesiredImuSourceActionArgs>, I>>(base?: I): SetDesiredImuSourceActionArgs {
    return SetDesiredImuSourceActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetDesiredImuSourceActionArgs>, I>>(
    object: I,
  ): SetDesiredImuSourceActionArgs {
    const message = createBaseSetDesiredImuSourceActionArgs();
    message.source = object.source ?? 0;
    return message;
  },
};

function createBaseSetDesiredImuSourceResultData(): SetDesiredImuSourceResultData {
  return {};
}

export const SetDesiredImuSourceResultData = {
  encode(_: SetDesiredImuSourceResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetDesiredImuSourceResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDesiredImuSourceResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetDesiredImuSourceResultData {
    return {};
  },

  toJSON(_: SetDesiredImuSourceResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetDesiredImuSourceResultData>, I>>(base?: I): SetDesiredImuSourceResultData {
    return SetDesiredImuSourceResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetDesiredImuSourceResultData>, I>>(_: I): SetDesiredImuSourceResultData {
    const message = createBaseSetDesiredImuSourceResultData();
    return message;
  },
};

function createBaseSetDesiredImuSourceActionStateData(): SetDesiredImuSourceActionStateData {
  return {};
}

export const SetDesiredImuSourceActionStateData = {
  encode(_: SetDesiredImuSourceActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetDesiredImuSourceActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDesiredImuSourceActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetDesiredImuSourceActionStateData {
    return {};
  },

  toJSON(_: SetDesiredImuSourceActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetDesiredImuSourceActionStateData>, I>>(
    base?: I,
  ): SetDesiredImuSourceActionStateData {
    return SetDesiredImuSourceActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetDesiredImuSourceActionStateData>, I>>(
    _: I,
  ): SetDesiredImuSourceActionStateData {
    const message = createBaseSetDesiredImuSourceActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
